import React, { useState, useEffect,  useContext  } from "react";
import group9 from "../../../images/LandingPageImage/whatsapp_bulk_send_about_us.webp";
import google from "../../../images/LandingPageImage/google.png";
import { useNavigate } from "react-router-dom";
import LandingNav from "../Landing_Nav";
import LandingFooter from "../Landing_Footer";
import CtaSection from "./CtaSection";
import { FiChevronUp, FiChevronDown } from "react-icons/fi";
import MyContext from "../../../MyContext";
import { useLocation } from "react-router-dom";


const slideData = {
  id: 1,
  subtitle:
    "Send messages, automate replies, manage chats, and run campaigns with a simple and powerful WhatsApp workspace built for growing businesses.",
  image: group9,
    ctaPrimary: "Start Free Trial",
  ctaSecondary: "Start Free Trial",
};

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
const { openFreeTrialModal } = useContext(MyContext);
  const [openIndex, setOpenIndex] = useState(null);
const location = useLocation();

  const arrowStyle = { width: "20px", height: "20px", flexShrink: 0 };
  const faqs = [
    {
      question: "Is AkaSoft easy to use for beginners",
      answer:
        "  Yes! Our platform is designed to be user-friendly with an intuitive dashboard, making it simple for anyone to create campaigns, automate messages, and manage contacts without technical experience.",
    },

    {
      question: " Can I send personalized messages to my customers?",
      answer:
        " Absolutely. You can automatically personalize messages using customer details like name, location, or past interactions, making every message feel more personal and engaging.",
    },

    {
      question: "How does automation help my business?",
      answer:
        "  Automation saves time by handling repetitive tasks like replies and follow-ups. It ensures your customers get instant responses, keeps conversations consistent, and frees your team to focus on higher-priority work.",
    },

    {
      question: " Is AkaSoft suitable for small businesses?",
      answer:
        " Yes! Our platform is built to scale with your business. Whether you’re a small startup or a growing enterprise, you can use our tools to manage campaigns, segment audiences, and automate communication effectively.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    // small stagger so animations appear after mount
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const slide = slideData;

 useEffect(() => {
  const pageKey = location.pathname;
  const storageKey = `freeTrialClosed_${pageKey}`;

  if (!sessionStorage.getItem(storageKey)) {
    openFreeTrialModal(pageKey);
  }

  return () => {
    sessionStorage.removeItem(storageKey);
  };
}, [location.pathname]);



  return (
    <>
      <style>{`
        :root {
          --hero-bg-1: #280410;
          --hero-bg-2: #9e104c;
          --accent: #f11960;
          --accent-light: #ffb3d1;
          --max-width: 1600px;

          /* THESE MUST MATCH LandingNav .ln-container paddings */
          --nav-padding-desktop: 5rem;   /* desktop padding in LandingNav */
          --nav-padding-xl: 4rem;        /* <=1400px */
          --nav-padding-lg: 3rem;        /* <=1200px */
          --nav-padding-md: 2rem;        /* <=992px */
          --nav-padding-sm: 1.25rem;     /* <=768px */
        }

        .hero-section {
          width: 100%;
          background: linear-gradient(135deg, var(--hero-bg-1), var(--hero-bg-2));
          padding: 4rem 0;
          position: relative;
          overflow: hidden;
          min-height: 500px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-bottom: 0;
        }

        /* hero-container uses same left padding as navbar so text aligns under logo */
        .hero-container {
          width: 100%;
          max-width: var(--max-width);
          margin: 0 auto;
          display: flex;
          padding-left: var(--nav-padding-desktop);
          padding-right: var(--nav-padding-desktop);
          align-items: center;
          justify-content: space-between;
          gap: 2rem;
        }

        /* left column */
        .hero-left {
          flex: 1 1 48%;
          max-width: 720px;
          z-index: 3;
          text-align: left;
        }

        .hero-title {
          font-size: 2.6rem;
          font-weight: 700;
          line-height: 1.12;
          color: #ffffff;
          margin: 0;
          opacity: 0;
          transform: translateX(-110%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1), transform 900ms cubic-bezier(.2,.9,.2,1);
        }

        .hero-title.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .pink-text {
          color: var(--accent);
        }

        .hero-sub {
          margin-top: 1rem;
          font-size: 1.05rem;
          color: #ffffff;
          line-height: 1.5;
          max-width: 45ch;
          opacity: 0;
          transform: translateX(-110%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 150ms, transform 900ms cubic-bezier(.2,.9,.2,1) 150ms;
        }

        .hero-sub.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .hero-ctas {
          margin-top: 1.5rem;
          display: flex;
          gap: 0.9rem;
          flex-wrap: wrap;
          opacity: 0;
          transform: translateX(-110%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 250ms, transform 900ms cubic-bezier(.2,.9,.2,1) 250ms;
        }

        .hero-ctas.visible {
          opacity: 1;
          transform: translateX(0);
        }

        .btn-primary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 28px;
          padding: 0.6rem 1.2rem;
          font-weight: 700;
          cursor: pointer;
          border: none;
          outline: none;
          white-space: nowrap;
          background: var(--accent);
          color: #fff;
          transition: background 200ms ease, color 200ms ease, transform 150ms ease;
        }

        .btn-primary:hover,
        .btn-primary:focus {
          background: var(--accent-light);
          color: var(--accent);
          transform: translateY(-2px);
        }

         .btn-secondary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 28px;
          padding: 0.6rem 1.2rem;
          font-weight: 700;
          cursor: pointer;
          border: none;
          outline: none;
          white-space: nowrap;
          background: var(--accent);
          color: #fff;
          transition: background 200ms ease, color 200ms ease, transform 150ms ease;
        }

        .btn-secondary:hover,
        .btn-secondary:focus {
          background: var(--accent-light);
          color: var(--accent);
          transform: translateY(-2px);
        }

        /* right column - image */
        .hero-right {
          flex: 1 1 48%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 1;
          max-width: 720px;
          height: 520px;
          padding-right: calc(var(--nav-padding-desktop) * 0.6); /* slight offset to match visual balance with nav */
        }

        .hero-image {
          width: 100%;
          height: 100%;
          object-fit: contain;
          opacity: 0;
          transform: translateX(80%);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 120ms, transform 900ms cubic-bezier(.2,.9,.2,1) 120ms;
          pointer-events: none;
          user-select: none;
          max-width: 100%;
          max-height: 100%;
        }

        .hero-image.visible {
          opacity: 1;
          transform: translateX(0);
        }

        /* Small aesthetic vignette/overlay to make text pop */
        .hero-overlay {
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: radial-gradient(800px 400px at 10% 30%, rgba(255,255,255,0.03), transparent 10%),
                      radial-gradient(600px 300px at 90% 70%, rgba(0,0,0,0.18), transparent 15%);
          z-index: 2;
        }

        /* Responsive paddings that match LandingNav breakpoints */
        @media (max-width: 1400px) {
          .hero-container {
            padding-left: var(--nav-padding-xl);
            padding-right: var(--nav-padding-xl);
          }
        }

        @media (max-width: 1200px) {
          .hero-container {
            padding-left: var(--nav-padding-lg);
            padding-right: var(--nav-padding-lg);
          }
        }

        @media (max-width: 992px) {
          .hero-container {
            padding-left: var(--nav-padding-md);
            padding-right: var(--nav-padding-md);
            flex-direction: column;
            align-items: center;
            text-align: center;
          }

          .hero-left {
            max-width: 90%;
            margin: 0 auto;
          }

          .hero-title {
            text-align: center;
          }

          .hero-sub {
            text-align: center;
            max-width: 38ch;
            margin-left: auto;
            margin-right: auto;
          }

          .hero-ctas {
            justify-content: center;
            margin-bottom: 1.5rem;
          }

          .hero-right {
            height: 360px;
            padding-right: 0;
            margin-top: 0.5rem;
          }
        }

        @media (max-width: 768px) {
          .hero-container {
            padding-left: var(--nav-padding-sm);
            padding-right: var(--nav-padding-sm);
          }
          .hero-title { font-size: 1.6rem; }
          .hero-sub { font-size: 1rem; }
          .hero-right { height: 300px; }
        }

        @media (max-width: 480px) {
          .hero-container {
            padding-left: 1.2rem;
            padding-right: 1.2rem;
          }
          .hero-left { max-width: 95%; }
          .hero-right { height: 240px; }
        }
      `}</style>

      <LandingNav />
      <section
        className="hero-section"
        aria-label="AkaSoft hero section"
      >
        <div className="hero-container">
          {/* LEFT: Text */}
          <div className="hero-left">
            <h1 className={`hero-title ${isVisible ? "visible" : ""}`}>
              <span className="pink-text">Smart WhatsApp</span>
              <br />
              Automation for Businesses
            </h1>

            <p className={`hero-sub ${isVisible ? "visible" : ""}`}>
              {slide.subtitle}
            </p>

            <div className={`hero-ctas ${isVisible ? "visible" : ""}`}>
              <button
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={() => navigate("/login?provider=google")}
              >
                <span>Continue with</span>
                <img
                  src={google}
                  alt="Google"
                  style={{ width: "28px", height: "28px" }}
                />
              </button>

              
              <button onClick={openFreeTrialModal} className="btn-secondary">
                {slide.ctaPrimary}
              </button>
            </div>
          </div>

          {/* RIGHT: Image */}
          <div className="hero-right" aria-hidden="true">
            <img
              src={slide.image}
              alt="Illustration: WhatsApp automation workspace"
              className={`hero-image ${isVisible ? "visible" : ""}`}
              loading="lazy"
              draggable={false}
            />
            <div className="hero-overlay" aria-hidden="true" />
          </div>
        </div>
      </section>

      <>
        <style>{`
        .content-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 60px 20px;
        }

       .content-title {
            font-size: 32px;
            font-weight: 700;
            margin: 0 auto 24px;   
            display: flex;
            align-items: center;
            justify-content: center;
            max-width: 600px;
            text-align: center;
            color: #9e104c;
            }

            .content-para {
            max-width: 900px;
            margin: 0 auto 15px;
            line-height: 1.5;
            color: #444;
            font-size: 16px;
            text-align: center;
            }

        .card-row {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
          margin-top: 40px;
        }

        .info-card {
        //   border: 1px solid #e5e5e5;
          border-radius: 12px;
          padding: 24px;
          background: #ffb3d1;
        }

        .info-card h3 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 12px;
          text-align: left;
          color: #9e104c;
        }

        .info-card p {
          font-size: 15px;
          line-height: 1.6;
          color: #141414;
          text-align: left;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .content-title {
            font-size: 26px;
          }

          .card-row {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

        <div className="content-container">
          <h2 className="content-title">
            Simplifying Customer Engagement Through WhatsApp Automation
          </h2>

          <p className="content-para">
            At AkaSoft, we help businesses talk to their customers in a
            simple, natural, and effective way using WhatsApp. We believe
            communication should feel personal, not complicated, and our
            platform is built to make connecting with customers easy for teams
            of any size.
          </p>

          <p className="content-para">
            We focus on creating tools that save time while keeping
            conversations genuine. Whether it’s sending updates, answering
            questions, or reaching the right audience, our goal is to help
            businesses build better relationships through clear and meaningful
            communication.
          </p>

          {/* Cards */}
          <div className="card-row">
            <div className="info-card">
              <h3>Simplicity First</h3>
              <p>
                We believe great technology should be easy to use. Everything we
                build is designed to reduce complexity and make business
                communication straightforward for everyone, regardless of
                technical background.
              </p>
            </div>

            <div className="info-card">
              <h3>Customer-Centered Thinking</h3>
              <p>
                Our users are at the heart of every decision we make. We listen,
                learn, and improve continuously to ensure our platform truly
                solves real communication challenges faced by businesses.
              </p>
            </div>

            <div className="info-card">
              <h3>Reliability You Can Trust</h3>
              <p>
                Consistency and dependability matter in business communication.
                We are committed to providing a platform businesses can rely on
                every day to communicate without interruptions or uncertainty.
              </p>
            </div>

            <div className="info-card">
              <h3>Growth Through Innovation</h3>
              <p>
                We believe in evolving with our customers. By continuously
                improving our features and workflows, we help businesses adapt,
                scale, and grow smarter over time. Our users are at the heart of
                every decision we make. We listen, learn, and improve
                continuously to ensure our platform truly solves real
                communication challenges faced by businesses.
              </p>
            </div>
          </div>
        </div>
      </>

      <>
        <style>{`
        .section-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 60px 20px;
        }

        .section-title {
          font-size: 32px;
          font-weight: 700;
          text-align: center;
          margin-bottom: 16px;
          color: #9e104c;
        }

        .section-para {
          font-size: 16px;
          line-height: 1.7;
          text-align: center;
          max-width: 600px;
          margin: 0 auto 40px;
          color: #444;
        }

        .section-para1 {
          font-size: 18px;
          line-height: 1.4;
          text-align: left;
          max-width: 900px;
          margin: 0 auto;
          color: #444;
          margin-top: 15px;
        }

        .info-card1 {
          border: 1px solid #e5e5e5;
          border-radius: 12px;
          padding: 40px;
          background: #f11960;
          max-width: 900px;
          margin: 0 auto;
        }

        .card-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 40px;
        }

        .card-side h3 {
          font-size: 20px;
          font-weight: 600;
          margin-bottom: 12px;
          text-align: left;
          color: #ffffff;
        }

        .card-side p {
          font-size: 15px;
          line-height: 1.6;
          color: #ffffff;
          text-align: left;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .section-title {
            font-size: 26px;
          }

          .card-content {
            grid-template-columns: 1fr;
            gap: 24px;
          }

          .info-card {
            padding: 24px;
          }
        }
      `}</style>

        <div className="section-container">
          <h2 className="section-title">What We Do</h2>

          {/* Center Paragraph */}
          <p className="section-para">
            At AkaSoft, we help businesses talk to their customers in a
            simple, natural, and effective way using WhatsApp.
          </p>

          {/* Card */}
          <div className="info-card1">
            <div className="card-content">
              {/* Left Side */}
              <div className="card-side">
                <p>
                  Help businesses communicate with customers directly through
                  WhatsApp in a simple and efficient way
                </p>

                <p>
                  Enable teams to send campaigns, updates, and announcements
                  without manual effort
                </p>

                <p>
                  Make it easy to reach the right audience with targeted and
                  organized messaging
                </p>
              </div>

              {/* Right Side */}
              <div className="card-side">
                <p>
                  Support personalized communication that feels natural and
                  relevant to each customer
                </p>
                <p>
                  Automate replies to customer inquiries to ensure fast and
                  consistent responses
                </p>
                <p>
                Support businesses as they grow by offering scalable and
                easy-to-manage communication solution
               </p>
              </div>
            </div>
          </div>
        </div>
      </>

      {/* forth section */}

      <div
        className="container-fluid d-flex flex-column"
        style={{ background: "#ffffff" }}
      >
        <div className="row mt-4 mb-5">
          <div className="col-lg-3 d-none d-lg-block"></div>
          <div className="col-12 col-lg-6 px-3 px-md-4">
            <h2 className="text-center text-black mt-5 mb-4 fs-4">
              Frequently Asked Questions
            </h2>

            <div className="row ">
              <div className="col-12 p-3">
                {faqs.map((faq, index) => {
                  const isOpen = openIndex === index;

                  return (
                    <div
                      key={index}
                      onClick={() => toggleFAQ(index)}
                      style={{
                        background: isOpen ? "#EFEFEF" : "#D9D9D9",
                        borderRadius: "12px",
                        padding: "20px 18px",
                        marginBottom: "14px",
                        cursor: "pointer",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <p
                          className="mb-0"
                          style={{
                            fontSize: "18px",
                            minWidth: "200px",
                            color: isOpen ? "#000000" : "#000000",
                            fontWeight: isOpen ? "600" : "400",
                          }}
                        >
                          {faq.question}
                        </p>

                        {isOpen ? (
                          <FiChevronUp style={arrowStyle} color="#000000" />
                        ) : (
                          <FiChevronDown style={arrowStyle} color="#000000e0" />
                        )}
                      </div>

                      {isOpen && (
                        <p
                          style={{
                            fontSize: "15px",
                            color: "#6F7D98",
                            marginTop: "10px",
                            lineHeight: "1.5",
                            maxWidth: "85%",
                          }}
                        >
                          {faq.answer}
                        </p>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="col-lg-3 d-none d-lg-block"></div>
        </div>
      </div>

      <CtaSection />
      <LandingFooter />
    </>
  );
};

export default About;
